/** Live download landing — always use this in QR so phone scans work (not localhost). */
export const QR_DOWNLOAD_URL = 'https://www.sahabalalam.sa/download.html'

/**
 * High-res QR image URL (ecc=H tolerates center logo overlay).
 * Request a large pixel size so it stays sharp when scaled down on screen / print.
 * @param {string} data
 * @param {number} size
 */
export const getQrImageSrc = (data = QR_DOWNLOAD_URL, size = 600) =>
    `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&ecc=H&margin=1&format=png&qzone=1&data=${encodeURIComponent(data)}`
